module.exports = __webpack_public_path__ + "img/triangle-b@2x.8cce4263.png";